export default {
	title: "Web3",
	rule: "ルール説明",
	safe: "資金安全",
	balance: {
		total: "合計金額",
		yesterday: "昨日の収益",
		cumulatively: "累計収益",
		in: "入金額",
		out: "出金額",
		available: "利用可能残高"
	},
	actions: {
		in: "入金",
		out: "出金"
	},
	type: ["すべて", "入金", "出金", "収益"],
	TransactionPassword: "トランザクションパスワード",
	Amount: "金額",
	date: "日付"
};
